export default __webpack_public_path__ + "static/media/image7.599d8233.png";